// Fetch list

export const FETCH = 'dietRates.FETCH'
export const FETCH_STARTED = 'dietRates.FETCH_STARTED'
export const FETCH_FULFILLED = 'dietRates.FETCH_FULFILLED'
export const FETCH_REJECTED = 'dietRates.FETCH_REJECTED'
export const FETCH_CANCELLED = 'dietRates.FETCH_CANCELLED'

export const SORTING_CHANGED = 'dietRates.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'dietRates.FETCH_ONE'
export const FETCH_ONE_STARTED = 'dietRates.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'dietRates.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'dietRates.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'dietRates.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'dietRates.SAVE'
export const SAVE_STARTED = 'dietRates.SAVE_STARTED'
export const SAVE_FULFILLED = 'dietRates.SAVE_FULFILLED'
export const SAVE_REJECTED = 'dietRates.SAVE_REJECTED'
export const SAVE_CANCELLED = 'dietRates.SAVE_CANCELLED'

// Delete

export const DELETE = 'dietRates.DELETE'
export const DELETE_STARTED = 'dietRates.DELETE_STARTED'
export const DELETE_FULFILLED = 'dietRates.DELETE_FULFILLED'
export const DELETE_REJECTED = 'dietRates.DELETE_REJECTED'
export const DELETE_CANCELLED = 'dietRates.DELETE_CANCELLED'

// Export

export const EXPORT = 'dietRates.EXPORT'
export const EXPORT_FULFILLED = 'dietRates.EXPORT_FULFILLED'
